import Link from '@/components/i18n/LocaleLink';
import Image from 'next/image';
import type { TranslationKeys } from '../translations';

interface FooterSectionProps {
  t: TranslationKeys;
}

export default function FooterSection({ t }: FooterSectionProps) {
  return (
      <footer className="bg-gray-50 border-t border-gray-200 pt-12 pb-6 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Top section with logo, description and links */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pb-12 border-b border-gray-200">
            {/* Logo and description */}
            <div className="col-span-2">
              <Link href="/" className="flex items-center gap-2 mb-4">
                <Image src="/images/brand/ezdocuai-logo.png" alt="EZDocuAI" width={32} height={32} className="h-8 w-8" />
                <span className="text-xl font-bold" style={{ color: '#ab5af6' }}>EZDocuAI</span>
              </Link>
              <p className="text-sm text-gray-500 max-w-xs">
                {t.footerDesc}
              </p>
            </div>

            {/* Product links */}
            <div>
              <h3 className="font-medium text-gray-900 mb-4 text-base">{t.product}</h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li><Link href="#features" className="hover:text-gray-900 transition-colors">{t.features}</Link></li>
                <li><Link href="#pricing" className="hover:text-gray-900 transition-colors">{t.pricing}</Link></li>
                <li><Link href="#how-it-works" className="hover:text-gray-900 transition-colors">{t.howItWorks}</Link></li>
              </ul>
            </div>

            {/* Resources links */}
            <div>
              <h3 className="font-medium text-gray-900 mb-4 text-base">{t.resources}</h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li><Link href="/blog" className="hover:text-gray-900 transition-colors">{t.blog}</Link></li>
                <li><Link href="/help" className="hover:text-gray-900 transition-colors">{t.helpCenter}</Link></li>
                <li><Link href="/help/novedades" className="hover:text-gray-900 transition-colors">{t.whatsNew}</Link></li>
                <li><Link href="mailto:hello@ezdocu.ai" className="hover:text-gray-900 transition-colors">{t.support}</Link></li>
              </ul>
            </div>

            {/* Company links */}
            <div>
              <h3 className="font-medium text-gray-900 mb-4 text-base">{t.company}</h3>
              <ul className="space-y-3 text-sm text-gray-600">
                <li><Link href="/privacy" className="hover:text-gray-900 transition-colors">{t.privacyPolicy}</Link></li>
                <li><Link href="/terms" className="hover:text-gray-900 transition-colors">{t.termsConditions}</Link></li>
                <li><Link href="/cookies" className="hover:text-gray-900 transition-colors">{t.cookiePolicy}</Link></li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} EZDocuAI, Inc. {t.allRightsReserved}</p>
          </div>

        </div>
      </footer>
  );
}
